import React, { Component } from "react";
import Navbar from "./modules/Navbar";
import Hero from "./modules/Hero";
import Popup from "./modules/Popup";
import About from "./modules/About";
import Categories from "./modules/Categories";
import Prizes from "./modules/Prizes";
import Timeline from "./modules/Timeline";
import Training from "./modules/Training";
import Partners from "./modules/Partners";
import Register from "./modules/Register";
import Gallery from "./modules/Gallery";
import Video from "./modules/Video";
import Faq from "./modules/Faq";
import Contact from "./modules/Contact";
import Footer from "./modules/Footer";
import ScrollButton from "./modules/ScrollButton";
import { Helmet } from "react-helmet";
import "./scss/App.scss";
import MessageEN from "./l10n/en_sg";
import MessageTH from "./l10n/th_th";

class Application extends React.Component {
  constructor(props) {
    super(props);
    // this.title = "Shopee Thailand Data Challenge  2020";
    // this.desc =
    //   "Thailand Data Challenge 2020, proudly organised by Shopee is the largest data analytic competition in Thailand. The challenge is a one day data analytic competition open to all students and professionals .The competition consists of 2 rounds of Data Science and Data Analytics problems designed by Shopee Tech Teams. Participants must analyse the dataset, draw insightful conclusions and solve the problems in a specified amount of time. Not only will participants get a chance to code to generate insights that solve real industry problems, this competition will also provide them with an opportunity to test their coding skills and understand the importance of data analytic skills required in Shopee. It is free and open to tech and non-tech professionals working in Thailand as well as students currently enrolled in High School, polytechnics or universities in Thailand (including exchange students or other nationalities professionals). Register now as a group of 2 to 4 people and stand a chance to win over 100,000 baht in cash and Shopee coins prizes!  All winners of each category will be exclusively invited to visit Shopee Singapore’s office. Do not wait and hurry up to register and join the fun.";
    this.url = "https://careers.shopee.co.th/thdatachallenge";
    this.imageURL =
      "https://careers.shopee.co.th/thdatachallenge/images/header_seo.png";
  }
  render() {
    const msg = this.props.Message;
    this.title = msg.siteTitle;
    this.desc = msg.siteDesc;
    return (
      <div className="application">
        <Helmet
          title={this.title}
          titleAttribute={{ itemprop: "name", lang: "en" }}
          meta={[
            { name: "author", content: "sjDu" },
            { name: "description", content: this.desc },
            { name: "robots", content: "index, follow" },
            { property: "og:title", content: this.title },
            { property: "og:site_name", content: this.title },
            { property: "og:type", content: "website" },
            { property: "og:url", content: this.url },
            { property: "og:image", content: this.imageURL },
            { property: "og:description", content: this.desc }
          ]}
          link={[{ rel: "canonical", href: this.url }]}
          script={[
            {
              type: "application/ld+json",
              innerHTML: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Event",
                name: this.title,
                description: this.desc,
                image: this.imageURL,
                startDate: "2020-01-25T00:00+07:00",
                endDate: "2020-03-08T23:59+07:00",
                url: this.url,
                Performer: "Shopee Singapore",
                audience: {
                  audienceType:
                    "Students and Professionals passionate about Data!",
                  "@type": "EducationalAudience",
                  educationalRole: "Students passionate about Data analytic"
                },
                location: {
                  "@type": "Place",
                  name: "University Sports Centre, NUS ",
                  address:
                    "2 Sports Drive 1, National University of Singapore, Singapore 117561",
                  hasMap: "https://goo.gl/maps/mp7uGNfx928AG6688"
                },
                offers: {
                  "@type": "Offer",
                  price: "3000",
                  url: this.url,
                  priceCurrency: "SGD",
                  availability: "http://schema.org/InStock",
                  validFrom: "2019-10-20"
                }
              })
            }
          ]}
        />
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: navigator.language.slice(0, 2)
    };
    this.onChildChange = this.onChildChange.bind(this);
  }
  onChildChange(v) {
    this.setState({
      lang: v
    });
  }
  render() {
    var Message;
    switch (this.state.lang) {
      case "en-US":
      case "en":
        Message = MessageEN;
        break;
      case "th":
        Message = MessageTH;
        break;
      default:
        Message = MessageTH;
        break;
    }
    return (
      <div className="App">
        <Popup Message={Message}/>
        <Application Message={Message} />
        <Navbar
          Message={Message}
          onInputChange={this.onChildChange}
          value={this.state.lang}
        />
        <ScrollButton scrollStepInPx="150" delayInMs="0.66" />
        <Hero Message={Message} />
        <About Message={Message} />
        <Categories Message={Message} />
        <Prizes Message={Message} />
        <Timeline Message={Message} />
        <Training Message={Message} />
        <Register Message={Message} />
        {/* <Gallery Message={Message} />
        <Video /> */}
        <Faq Message={Message} />
        <Partners Message={Message} />
        <Contact Message={Message} />
        <Footer Message={Message} />
      </div>
    );
  }
}

export default App;
